import { publicApi } from 'lib/api'
import to from 'lib/to'

export const getTrainingPeriod = () => to(publicApi.get('/trainingPeriod.json'))
